import {createSelector} from 'reselect'

import {
  getState,
  setForm,
  updateForm,
  removeForm,
  formsSelector,
} from '../../store.js'
import {TRANSFER_URI_COMPONENT} from '../../common/constants/Transfers.js'
import {showGlobalError} from '../GlobalErrorMessage.js'
import {transferSelector, ensureTransfer} from '../../data/transfers.js'
import {locationSelector} from '../../redux/selectors/ui/location.js'
import {navigate} from '../../common/location.js'
import {buildPath} from '../../common/querystring.js'

export const TRANSFER_DETAIL_FORM = 'transfer_detail'

export function transferDetailFormSelector(state) {
  return formsSelector(state)[TRANSFER_DETAIL_FORM]
}

export const transferDetailTransferIDSelector = createSelector(
  locationSelector,
  ({pathComponents}) => {
    if (pathComponents[0] === TRANSFER_URI_COMPONENT && pathComponents[1]) {
      return pathComponents[1]
    }

    return null
  },
)

export function transferDetailURLSelector(state, {transferID}) {
  const pathComponents = [TRANSFER_URI_COMPONENT, transferID]

  return '#' + buildPath(pathComponents)
}

export const isLoadingListSelector = createSelector(
  transferDetailFormSelector,
  ({isLoadingList} = {}) => isLoadingList || false,
)

export function navigateToTransferDetailPage(transferID) {
  const pathComponents = [TRANSFER_URI_COMPONENT, transferID]

  return navigate(pathComponents)
}

export function setupTransferDetailForm() {
  setForm(TRANSFER_DETAIL_FORM, {
    isLoading: true,
  })
}

export function updateTransferDetailForm(updates, meta) {
  updateForm(TRANSFER_DETAIL_FORM, updates, meta)
}

export function removeTransferDetailForm() {
  removeForm(TRANSFER_DETAIL_FORM)
}

export async function getCurrentDetailTransfer() {
  const transferID = transferDetailTransferIDSelector(getState())

  try {
    if (!transferID) {
      return
    }

    const transfer = transferSelector(getState(), {transferID})

    updateTransferDetailForm({isLoading: !transfer})

    await ensureTransfer(transferID, {reload: true})
  } catch (err) {
    if (!err.response || err.response.status !== 404) {
      showGlobalError(
        {
          summary: `There was an error loading Transfer Details for ${transferID}.`,
          details: err.message,
        },
        err,
      )
    }
  }

  updateTransferDetailForm({isLoading: false})
}
